export enum LoginApps {
  phc = 'phc',
  lifeology = 'lifeology',
  marketplace = 'marketplace',
}
